import { Content } from './src/Content.js';
import { Footer } from './src/Footer.js';
import { Header } from './src/Header.js';
import { Sheet as Sheet$1 } from './src/Sheet.js';

const Sheet = Sheet$1;
Sheet.Header = Header;
Sheet.Footer = Footer;
Sheet.Content = Content;

export { Sheet };
//# sourceMappingURL=index.js.map
